import styles from './style.module.css';

import {ComponentWithChildrenProps} from '@interfaces/component';

interface CardBodyProps extends ComponentWithChildrenProps {
  classNames?: string;
}
export default function CardBody({children, classNames = ''}: CardBodyProps) {
  return <div className={`${styles.cardBody} ${classNames}`}>{children}</div>;
}
